import { useState } from "react";
import { INotification } from "./NotificationInterface";
import { StyledList, NDTitle, StyledGroupHeader, GroupChevron } from "./styles";
import { useTranslation } from "react-i18next";
import Notification from "./Notification";
import { NotificationGroup } from "./notificationGrouping";

const ChevronIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path
      d="M6 9l6 6 6-6"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const NotificationList = (props: any): JSX.Element => {
  const { t } = useTranslation();
  const { notifications, groups, onSelect, onDelete, onToggleRead, applications } = props;
  const [collapsed, setCollapsed] = useState<Record<string, boolean>>({});

  const toggleGroup = (id: string) =>
    setCollapsed((prev) => ({ ...prev, [id]: !prev[id] }));


  const resolvedGroups: NotificationGroup[] = groups
    ? groups
    : [
        {
          id: "__all__",
          label: "",
          items: (notifications || []).filter((n: INotification) => !n.deleted),
        },
      ];

  const total = resolvedGroups.reduce((sum, g) => sum + g.items.length, 0);

  return (
    <StyledList data-testid="notification-list">
      {total === 0 && (
        <NDTitle style={{ padding: "16px" }}>
          {t("notification.sheet.nomessage")}
        </NDTitle>
      )}
      {applications &&
        resolvedGroups.map((group) =>
          group.items.length === 0 ? null : (
            <div key={group.id} data-testid={"notification-group-" + group.id}>
              {group.label && (
                <StyledGroupHeader
                  onClick={() => toggleGroup(group.id)}
                  data-testid={"notification-group-header-" + group.id}
                >
                  <span>{group.label} ({group.items.length})</span>
                  <GroupChevron collapsed={!!collapsed[group.id]}>
                    <ChevronIcon />
                  </GroupChevron>
                </StyledGroupHeader>
              )}
              {!collapsed[group.id] &&
                group.items.map((notification: INotification, indx: number) =>
                  notification.deleted ? null : (
                    <Notification
                      key={notification.messageId + "-" + group.id + "-" + indx}
                      data-testid={"notification-item-" + indx}
                      notification={notification}
                      applications={applications}
                      onSelect={onSelect!}
                      onDelete={onDelete!}
                      onToggleRead={onToggleRead}
                    />
                  )
                )}
            </div>
          )
        )}
    </StyledList>
  );
};
export default NotificationList;
